module.exports = __webpack_public_path__ + "img/mcone.d5493a33.png";